import { Container, Spinner } from "react-bootstrap";
import { useState, useEffect } from "react";
import { db } from "../config/firebase";
import CodesList from "../components/CodesList";
import StoreDetails from "../components/StoreDetails";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import FourOfFour from "../components/FourOfFour";

import axios from "axios";

const Store = () => {
  const { slug } = useParams();
  const [store, setStore] = useState({});
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [location, setLocation] = useState({});
  // const [loading2, setLoading2] = useState(true);

  // useEffect(() => {
  //   getLocation()
  // }, [loading2])

  const getLocation = async () => {
    await axios.get("https://ipapi.co/json/").then((response) => {
      setLocation(response.data);
      // setLoading2(false)
    });
  };

  useEffect(() => {
    const fetchAPI = async () => {
      try {
        await db
          .collection("stores")
          .where("slug", "==", slug.toLowerCase())
          .get()
          .then((snapshot) => {
            if (snapshot.empty) {
              setError(true);
            } else {
              snapshot.forEach((storeF) => {
                let storewithId = { ...storeF.data(), id: storeF.id };
                setStore(storewithId);
              });
            }
          });
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchAPI();
  }, [slug]);

  useEffect(() => {
    const fetchAPI2 = async () => {
      if (store.id !== undefined) {
        try {
          var dbCodes = [];
          await db
            .collection("codes")
            .where("storeId", "==", store.id)
            .get()
            .then((snapshot) => {
              snapshot.forEach((codeF) => {
                let codeWithID = { ...codeF.data(), id: codeF.id };
                dbCodes = [...dbCodes, codeWithID];
              });
            });
          setCodes(dbCodes);
          setLoading(false);
        } catch (error) {
          console.log(error.message);
        }
      }
    };
    getLocation();
    fetchAPI2();
  }, [store]);

  if (loading) {
    return (
      <Container className="mx-auto my-5 d-flex justify-content-center">
        <Spinner animation="border" />
      </Container>
    );
  } else if (
    error ||
    !(
      location.country === "SA" ||
      location.country === "AE" ||
      location.country === "KW" ||
      location.country === "OM" ||
      location.country === "QA" ||
      location.country === "BH"
    ) &
      (store.nameEn === "iHerb")
  ) {
    return <FourOfFour />;
  }

  return (
    <Container fluid className="mx-auto my-4">
      <Helmet>
        <title>
          تطبيق أكواد: كود خصم {store.nameAr} {store.nameEn}
        </title>
        <meta
          name="description"
          content={`كود خصم ${store.nameAr} ${store.nameEn}  ، كوبون ، عروض ، خصومات، تخفيضات حصرية`}
        />
      </Helmet>

      <StoreDetails store={store} />

      <CodesList codes={codes} store={store} />
    </Container>
  );
};

export default Store;
